import { AppLanguage } from '~/types/locale'

import { CurriculumCountryCodes } from '../constants/curriculum.const'

export default function getLanguageFromCurriculumCode(curriculumCountryCode: string): AppLanguage {
  switch (curriculumCountryCode) {
    case CurriculumCountryCodes.NORWAY:
      return AppLanguage.NO

    case CurriculumCountryCodes.UKRAINIAN:
      return AppLanguage.UA

    default:
      return AppLanguage.EN
  }
}
